import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_MATCHES = "getPaginatedMatches";
export const FIND_BY_MATCH_NAME = "findByMatchName";
export const ALL_MATCHES = "getAllMatches";
export const ALL_MATCHES_AFTER_TODAY = "getAllMatchesAfterToday";
export const CREATE_MATCH_FORM = "createMatchForm";
export const DELETE_MATCH = "deleteMatch";
export const GET_MATCH_DATA = "getMatchData";
export const CREATE_MATCH = "createMatch";
export const UPDATE_MATCH = "updateMatch";


// mutation types

export const SET_PAGINATED_MATCHES = "setPaginatedMatches";
export const SET_ALL_MATCHES = "setAllMatches";
export const SET_MATCH_DATA = "setMatchData";
export const SET_MATCH_META = "setMatchMeta";
export const SET_MATCH_ERROR = "setMatchError";
export const SET_MATCH_LOADING = "setMatchLoading";
export const CLEAR_MATCH_ERROR = "clearMatchError";
export const SET_IS_DISABLED_MATCH = "setIsDisabledMatch";


const state = {
    matches: [],
    paginatedMatches: [],
    match_data: {},
    meta_match : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllMatches(state) {
        return state.paginatedMatches;
    },

    allMatches(state) {
        return state.matches;
    },

    getMatchData(state) {
        return state.match_data;
    },

    meta_match(state) {
        return state.meta_match;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_MATCHES](context, payload) {
        context.commit(SET_IS_DISABLED_MATCH, false);
        context.commit(SET_MATCH_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/matches?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_MATCH_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_MATCHES, data);
                context.commit(SET_MATCH_META, data);
                context.commit(SET_MATCH_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_MATCH_LOADING, false);
            context.commit(SET_MATCH_ERROR, response.errors);
        });
        ;
        
    },

    [FIND_BY_MATCH_NAME](context, payload) {
        context.commit(SET_IS_DISABLED_MATCH, false);
        context.commit(SET_MATCH_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get(`/findByMatchName?searchText=${payload.searchText}&check=${payload.x}`)
            .then((response) => {
                resolve(response);
            })
        });
    },


    [ALL_MATCHES]() {
        return new Promise(resolve => {
            ApiService.get('/matchesAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [ALL_MATCHES_AFTER_TODAY]() {
        return new Promise(resolve => {
            ApiService.get('/matchesAllAfterToday')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_MATCH_FORM](context) {
        context.commit(SET_MATCH_LOADING, false);
        context.commit(SET_MATCH_ERROR, false);
        context.commit(SET_IS_DISABLED_MATCH, false);
    },

    [GET_MATCH_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_MATCH, true);
        context.commit(SET_MATCH_LOADING, true);
        context.commit(CLEAR_MATCH_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/match/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_MATCH_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_MATCH_DATA, response.data);
                    context.commit(SET_MATCH_LOADING, false);
                    context.commit(SET_IS_DISABLED_MATCH, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_MATCH_LOADING, false);
                context.commit(SET_MATCH_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_MATCH, true);
            });
        });
    },

    [CREATE_MATCH](context, payload) {
        context.commit(SET_MATCH_LOADING, false);
        context.commit(SET_IS_DISABLED_MATCH, true);
        context.commit(CLEAR_MATCH_ERROR);
        return ApiService.post("/match/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_MATCH_ERROR);
            }
            else{
                context.commit(SET_MATCH_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Maç başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_MATCH_ERROR);
                context.commit(SET_IS_DISABLED_MATCH, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_MATCH_LOADING, false);
            context.commit(SET_MATCH_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_MATCH, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_MATCH](context, payload) {
        context.commit(SET_MATCH_LOADING, true);
        context.commit(SET_IS_DISABLED_MATCH, true);
        context.commit(CLEAR_MATCH_ERROR);
        
        return ApiService.put(`/match/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_MATCH_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı maç başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_MATCH, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_MATCH_LOADING, false);
            context.commit(SET_MATCH_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_MATCH, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_MATCH](context, payload) {
        context.commit(SET_MATCH_LOADING, true);
        context.commit(CLEAR_MATCH_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/match/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_MATCH_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
               
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı maç başarıyla silinmiştir."
                );
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_MATCH_ERROR, error);
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_MATCHES](state, paginatedMatches) {
        state.paginatedMatches = paginatedMatches.data;
    },

    [SET_ALL_MATCHES](state, matches) {
        state.matches = matches;
    },

    [SET_MATCH_DATA](state, matches_data) {
        state.matches_data = matches_data;
        state.errors = [];
    },

    [SET_MATCH_META](state, meta_match) {
        state.meta_match = meta_match;
    },

    [SET_MATCH_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_MATCH_ERROR](state) {
        state.errors = [];
    },
    
    [SET_MATCH_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_MATCH](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
